// extracted by mini-css-extract-plugin
module.exports = {"redirection-button":"style_redirection-button__22FAJ","icon-wrapper":"style_icon-wrapper__3nj6P"};